import React, { useEffect, useState } from 'react';

/** Battle Badges only lays out on large enough screens; smaller windows get a notice over it. */
const BATTLE_MIN_WIDTH = 1300;
const BATTLE_MIN_HEIGHT = 800;

const readBattleViewport = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  return { width, height, fits: width >= BATTLE_MIN_WIDTH && height >= BATTLE_MIN_HEIGHT };
};

const useBattleViewport = () => {
  const [viewport, setViewport] = useState(readBattleViewport);
  useEffect(() => {
    const update = () => setViewport(readBattleViewport());
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  return viewport;
};

/** Hides /battle without unmounting it, so resizing never drops a match or draft. */
export const BattleViewportGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { fits, width, height } = useBattleViewport();
  return (
    <>
      <div className={`bb-screen${fits ? '' : ' is-hidden'}`}>{children}</div>
      {fits ? null : (
        <div className="bb-unsupported" role="alert">
          <h2>Battle Badges needs a bigger screen</h2>
          <p>
            Open it in a window at least {BATTLE_MIN_WIDTH}px wide and {BATTLE_MIN_HEIGHT}px tall to play.
          </p>
          <p>
            Yours is currently {width}px × {height}px.
          </p>
        </div>
      )}
    </>
  );
};
